import { editorPicks } from '@/mocks/ranking';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function RankingList() {
  return (
    <section id="rank" className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          tag="编辑精选"
          title="本周值得一看的八部作品"
          desc="结合评分、口碑与观看体验整理出的榜单，每一条都写清楚推荐理由，帮你减少纠结、直接开看。"
        />

        <ol className="space-y-3">
          {editorPicks.map((item) => {
            const isTop = item.rank <= 3;
            return (
              <li
                key={item.rank}
                className={`flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 p-4 md:p-5 rounded-xl border transition-colors ${
                  isTop
                    ? 'bg-background-50 border-primary-200'
                    : 'bg-background-50/70 border-background-200/70'
                }`}
              >
                <span
                  className={`w-11 h-11 flex-shrink-0 rounded-lg flex items-center justify-center font-heading text-lg font-bold ${
                    isTop
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
                      {item.kind}
                    </span>
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-2">
                    {item.reason}
                  </p>
                </div>

                <div className="flex items-center gap-4 sm:flex-col sm:items-end sm:gap-1 flex-shrink-0">
                  <span className="font-heading text-xl md:text-2xl font-bold text-accent-600">
                    {item.rating.toFixed(1)}
                  </span>
                  <span className="text-xs text-foreground-500">{item.year}</span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}